"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class OMQuery {
    // TODO: name clashing
    // private offset: number = 0
    // ROADMAP: Results Iterator
    // var iterator: ??
    /**
     * e.g. To query all Parties of a Group, we want the URL to be `/groups/:id/party`
     * @param objectType: `OMParty`
     * @param relName: `party`
     * @param relRef: `OMReference<OMGroup>`
     */
    constructor(objectType, relName, relRef) {
        this.objectType = objectType;
        this.relName = relName;
        this.relRef = relRef;
        this.results = [];
        this.resultObjects = [];
        // ROADMAP: Pagination
        this.itemsPerPage = 20;
        this.currentPage = 0;
        this.queries = [];
        this.includes = [];
        this.sorts = [];
    }
    // ROADMAP: Support pagination
    // func nextResults(completion: ((Error?)->Void)?) { }
    get URL() {
        if (this.relRef && this.relName) {
            return `${this.relRef.referencedClazz.Path}/${this.relRef.id}/${this.relName}`;
        }
        else {
            return this.objectType.Path;
        }
    }
    static queryBuilderFromFilter(keyPath, filterOperator, value) {
        const operand = (() => {
            switch (typeof value) {
                case "string":
                    return `'${value}'`;
                default:
                    return value;
            }
        })();
        const operator = (() => {
            switch (filterOperator) {
                case "like":
                    return "ILIKE";
                case "notLike":
                    return "NOT ILIKE";
                case "equals":
                    return "=";
                case "notEquals":
                    return "!=";
                case "lessThan":
                    return "<";
                case "lessThanEqual":
                    return "<=";
                case "moreThan":
                    return ">";
                case "moreThanEqual":
                    return ">=";
                case "isNotNull":
                    return "IS NOT NULL";
                case "isNull":
                    return "IS NULL";
                case "contains":
                    return "@>";
                case "isContainedBy":
                    return "<@";
                default:
                    break;
            }
        })();
        const queryString = (() => {
            switch (filterOperator) {
                case "like":
                case "notLike":
                    return `(${keyPath} ${operator} '%${value}%')`;
                case "contains":
                case "isContainedBy":
                    return `(${keyPath} ${operator} '{${value}}')`;
                case "isNull":
                case "isNotNull":
                    return `(${keyPath} ${operator})`;
                default:
                    return `(${keyPath} ${operator} ${operand})`;
            }
        })();
        return queryString;
    }
    // ROADMAP: Ability to build up query filters, sorting, etc
    search(query) {
        return this;
    }
    filterGroup(filters, joinOperator = "AND") {
        const queryString = filters
            .map((filter) => OMQuery.queryBuilderFromFilter.apply(undefined, filter))
            .join(` ${joinOperator} `);
        this.queries.push(`(${queryString})`);
        return this;
    }
    filter(keyPath, filterOperator, value) {
        const queryString = OMQuery.queryBuilderFromFilter(keyPath, filterOperator, value);
        this.queries.push(queryString);
        return this;
    }
    sort(keyPath, direction) {
        switch (direction) {
            case "ASC":
                this.sorts.push(`${keyPath}`);
                break;
            case "DESC":
                this.sorts.push(`-${keyPath}`);
                break;
            default:
                break;
        }
        return this;
    }
    limit(itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        return this;
    }
    offset(currentPage) {
        this.currentPage = currentPage;
        return this;
    }
    include(relationship) {
        this.includes = [...this.includes, relationship];
        return this;
    }
    override(viewName) {
        this.viewName = viewName;
        return this;
    }
    execute() {
        return (() => __awaiter(this, void 0, void 0, function* () {
            try {
                const objects = yield __1.OMUniverse.shared.apiClient.send({
                    method: "GET",
                    params: {
                        "filter": this.queries.length > 0 ? this.queries.join(" AND ") : undefined,
                        "include": this.includes.length > 0 ? this.includes.join(",") : undefined,
                        "page[number]": this.currentPage,
                        "page[size]": this.itemsPerPage,
                        "sort": this.sorts.length > 0 ? this.sorts.join(",") : undefined,
                        "view": this.viewName,
                    },
                    url: this.URL,
                })
                    .then((response) => {
                    this.request = response;
                    this.meta = response.data.meta;
                    return response;
                })
                    .then((response) => __1.OMUniverse.shared.apiClient.objectsFromResponse(this.objectType, response.data))
                    .then((results) => results.slice(0, this.itemsPerPage));
                this.results = objects.map((object) => {
                    return new __1.OMReference(this.objectType, object);
                });
                this.resultObjects = this.results.map((ref) => ref.actualObject);
                return this.results;
            }
            catch (error) {
                throw error;
            }
        }))();
    }
    clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    }
}
exports.default = OMQuery;
//# sourceMappingURL=OMQuery.js.map